import * as types from '../mutation-types'
import api from '@/api/leaderboard'

// initial state
const state = {
    leaderboard: {},
    loaded: false,
}

const getters = {
    leaderboard: state => state.leaderboard,
    leaderboardLoaded: state => state.loaded,
}

const actions = {
    getLeaderboard({ commit }, id) {
        commit(types.SET_LEADERBOARD_LOADED, false );
        api.getLeaderboard(id, {_embed: 1},(response) => {
            commit(types.SET_LEADERBOARD, response._embedded.leaderboard );
            commit(types.SET_LEADERBOARD_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_LEADERBOARD] (state, leaderboard ) {
        state.leaderboard = leaderboard
    },
    [types.SET_LEADERBOARD_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


